import { useQuery } from '@tanstack/react-query'

import type { Application } from '../../types/applications'
import api from '../../api'

const useSingleApplication = (applicationID: string) => {
	return useQuery({
		queryKey: ['applications', applicationID],
		queryFn: () => api.applications.getSingleApplication(applicationID, true),
		select(data) {
			if (data.body !== undefined) {
				const response = sortComments(data.body[0])
				return response as Application
			} else {
				let response = {} as Application
				response['status'] = 'ERROR'
				response['details'] = data
				return response
			}
		}
	})
}
const sortComments = (response: Record<any, any>) => {
	let sortedCommentResponse = JSON.parse(JSON.stringify(response))
	let comments = (response && response.comments) || []
	sortedCommentResponse['comments'] = comments.sort(
		(a: any, b: any) =>
			new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
	)
	return sortedCommentResponse
}

export default useSingleApplication
